var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    attrs: {
      "className": "header--light"
    }
  }, [_c('sub-visual', {
    attrs: {
      "sh": "기업소개",
      "sh2": "보도자료",
      "tabActive": "보도자료",
      "bg": "/images/sub/visual/sv1-4.jpg"
    }
  }), _c('div', {
    staticClass: "text-center color-white bg-black py-50 py-lg-74 w-100"
  }, [_c('v-container', [_c('h3', {
    staticClass: "tit font-weight-light font-italic",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_vm._v(" 신뢰할 수 있는 "), _c('strong', {
    staticClass: "font-weight-bold"
  }, [_vm._v("세일즈웍스 코리아")])]), _c('p', {
    staticClass: "tit-txt mt-10 mt-lg-24",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 국제적 네트워크와 체계적인 프로세스를 바탕으로 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 함께하는 모든 분께 신뢰를 드리고 있습니다. ")])])], 1), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h3', {
    staticClass: "tit"
  }, [_vm._v(" 보도자료 ")]), _c('p', {
    staticClass: "tit-txt"
  }, [_vm._v(" 언론에서 바라본 세일즈웍스 코리아 ")])]), _c('press-list')], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }